/**
 * Returns _true_ if `rx` is a Reactive
 * @param rx
 * @returns
 */
export const isReactive = (rx) => {
    if (typeof rx !== `object`)
        return false;
    if (rx === null)
        return false;
    return (`on` in rx && `onValue` in rx);
};
export const hasLast = (rx) => {
    if (!isReactive(rx))
        return false;
    if (`last` in rx) {
        const v = rx.last();
        if (v !== undefined)
            return true;
    }
    return false;
};
